import React from 'react';

// Placeholder data for logos (replace URLs with actual logo images)
const logos = [
  "https://skillsuprise.com/data/cyberPDF/company-logos/amazon.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/tcs.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/infosys.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/capgemini.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/wipro.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/bosch.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/byjus.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/congnizant.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/dassault system.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/brillio.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/riktam.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/persistent.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/paypal.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/DXC.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/platform.png",
  "https://skillsuprise.com/data/cyberPDF/company-logos/pepcoding.png",
];

// --- Internal CSS for all styling ---
const internalCSS = `
  /* --- Main Page Container --- */
  .alumni-page-container {
    background-color: #fff; /* White background */
    font-family: 'Times New Roman', Times, serif; /* Serif font like image */
    position: relative; /* Needed for the wavy bottom */
    overflow-x: hidden; /* Prevent horizontal scroll */
    padding-bottom: 150px; /* Space for the wave and page number */
    min-height: 100vh; /* Ensure it takes full height */
  }

  /* --- Title Section --- */
  .alumni-title-section {
    padding: 4rem 1rem 2rem 1rem;
    text-align: center;
  }

  .alumni-main-title {
    font-size: 3rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 1rem;
  }

  /* Decorative line */
  .title-decorator {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3rem;
  }

  .decorator-line {
    height: 2px;
    width: 80px;
    background: linear-gradient(to right, transparent, #4CAF50, transparent);
  }

  .decorator-icon {
    color: #4CAF50; /* Green */
    font-size: 1.5rem;
    margin: 0 0.75rem;
    /* You might need a specific icon library or SVG for the exact shape */
    /* Using a placeholder character */
    content: '✤'; 
  }

  /* --- Logos Grid Section --- */
  .logos-grid-section {
    padding: 0 1rem 1rem 1rem; /* Adjust padding as needed */
  }

  .logo-item {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100px; /* Ensures consistent height */
  }

  .logo-item img {
    max-width: 100%;
    max-height: 60px; /* Control logo height */
    object-fit: contain; /* Keep aspect ratio */
    
    opacity: 0.8;
  }

  /* --- Wavy Bottom Section --- */
  .wavy-bottom-svg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 0;
    pointer-events: none;
  }
  
  /* --- Page Number --- */
  .page-number {
    position: absolute;
    bottom: 10px; /* Position above the wave */
    right: 20px;
    font-size: 0.8rem;
    color: #6c757d;
    z-index: 1; /* Above the wave */
  }

  /* --- Responsive Adjustments --- */
  @media (max-width: 991.98px) { /* Tablets */
    .alumni-main-title { 
      font-size: 2.5rem;
    }
  }

  @media (max-width: 767.98px) { /* Mobile Devices */
     .alumni-page-container {
        padding-bottom: 120px; /* Less space for wave on mobile */
     }
     .alumni-main-title {
       font-size: 2rem;
     }
     .title-decorator {
       margin-bottom: 2rem;
     }
     /* CHANGED: Adjusted max-height for 3 columns */
     .logo-item img {
       max-height: 100px; 
     }
     .page-number {
       font-size: 0.7rem;
       right: 15px;
     }
  }
`;

const AlumniWorkAt = () => {
  return (
    <>
      <style>{internalCSS}</style>
      
      <div className="alumni-page-container">
        
        {/* --- 1. Title Section --- */}
        <div className="alumni-title-section">
          <h1 className="alumni-main-title">Our Alumni Work At</h1>
          <div className="title-decorator">
            <div className="decorator-line"></div>
            <span className="decorator-icon"></span> {/* Placeholder icon */}
            <div className="decorator-line"></div>
          </div>
        </div>
        
        {/* --- 2. Logos Grid Section --- */}
        <div className="logos-grid-section">
          <div className="container">
            {/* --- THIS IS THE CHANGE ---
              - row-cols-3: 3 columns on ALL screen sizes
            */}
            <div className="row row-cols-3 g-4 g-lg-5">
              {logos.map((logoUrl, index) => (
                <div className="col" key={index}>
                  <div className="logo-item">
                    <img src={logoUrl} alt={`Logo ${index + 1}`} />
                  </div>
                </div>
              ))}
              {/* Add empty columns if needed to fill the last row */}
               {logos.length % 3 === 2 && <div className="col"></div>}
               {logos.length % 3 === 1 && <><div className="col"></div><div className="col"></div></>}
            </div>
          </div>
        </div>

        {/* --- Page Number --- */}
        <div className="page-number"></div>
        
        {/* --- 3. Wavy Bottom SVG --- */}
        <svg 
          className="wavy-bottom-svg"
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 1440 320"
          style={{ height: '100px' }} // Control the wave height
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="waveGradientAlumni" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#8E9DFF', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#C0C8FF', stopOpacity: 1 }} />
            </linearGradient>
          </defs>
          <path 
            fill="url(#waveGradientAlumni)" 
            fillOpacity="0.7" 
            d="M0,224L48,213.3C96,203,192,181,288,176C384,171,480,181,576,202.7C672,224,768,256,864,261.3C960,267,1056,245,1152,218.7C1248,192,1344,160,1392,144L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>

      </div>
    </>
  );
};

export default AlumniWorkAt;